$(document).ready(function() {
setTimeout(function() {
  $('.collection-slides').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }

  ]
});
   }, 100);



 $('.main-slide').slick({
   slidesToShow: 1,
   slidesToScroll: 1,
   arrows: true,
   //fade: true,
   asNavFor: '.thumbnail-sliderr'
 });
 $('.thumbnail-sliderr').slick({
   slidesToShow: 4,
   slidesToScroll: 1,
   asNavFor: '.main-slide',
   dots: false,
   arrows: false,
   vertical:true,
   focusOnSelect: true
 });

  
});